<ul class="timeline">
  <li>
    <div class="direction-r">
      <div class="flag-wrapper">
        <span class="flag">Menino do rosto conhecido</span>
        <span class="time-wrapper">
          <span class="time">01/03/2019</span>
        </span>
      </div>
      <div class="desc">
        Tudo começou com um "oe, eu sou o João, o do rosto conhecido", e depois
        de várias conversas nos conectamos de tal forma que tudo que acontecia
        precisávamos contar um para o outro.
      </div>
    </div>
  </li>

  <li>
    <div class="direction-l">
      <div class="flag-wrapper">
        <span class="flag">Dia das mulheres</span>
        <span class="time-wrapper">
          <span class="time">08/03/2019</span>
        </span>
      </div>
      <div class="desc">
        Dia que trouxe a certeza para ela que ele seria o par perfeito para o
        enfim casados. Neste dia após um dia cansativo de trabalho ele chega com
        um arranjo de flores lindas e chocolate, todo tímido e sem jeito entrega
        os presentes e diz o quanto ela é especial, linda e sobre seu desejo de
        estar sempre ao seu lado.
      </div>
    </div>
  </li>
  <li>
    <div class="direction-r">
      <div class="flag-wrapper">
        <span class="flag">Nosso primeiro beijo</span>
        <span class="time-wrapper">
          <span class="time">17/03/2019</span>
        </span>
      </div>
      <div class="desc">
        Parece que foi ontem que estávamos indo na vigília da igreja. AH este
        dia haha... nos perdemos no valo velho e depois de lutarmos tanto para
        chegar, acabamos dormindo no culto, foi hilário. Ao voltarmos ele faz a
        pergunta "Quer namorar comigo?" ela toda tímida responde "sim, aceito"
        ele ainda continua "mas antes de dar o primeiro beijo vamos pedir a
        benção de Deus" e assim foi feito.
      </div>
    </div>
  </li>

  <li>
    <div class="direction-l">
      <div class="flag-wrapper">
        <span class="flag">O pedido de casamento</span>
        <span class="time-wrapper">
          <span class="time">12/06/2020</span>
        </span>
      </div>
      <div class="desc">
        Que dia incrível ... Naquele dia já estava tudo sendo preparado com todo
        amor e carinho. Ela quando chega na chácara se depara com uma câmera e
        uma luz forte no rosto, o pessoal da família bem empolgados e lançam um
        cartão com uma charada para um caça-tesouro cada um mais engraçado que o outro e
        empolgante. No fim ela se depara no destino final com vários balões na
        parede escrito "casa comigo?" e ele ajoelhado com a aliança, e ela
        chocada solta um sim aos prantos.
      </div>
    </div>
  </li>

</ul>
